export enum VisitorIntelMigrationDataSourceStatusEnum {
    SALES_INTEL = 'SALES_INTEL',
    BOMBORA = 'BOMBORA',
    BOTH = 'BOTH',
}
